import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { navItems } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    brand
  } = useBrand();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur" data-id="element-297" data-mp="i0ssn4fdd7zr">
      <div className="hidden border-b border-ink/10 bg-cream-deep text-ink-soft md:block" data-id="element-298" data-mp="vqwalj77ufje">
        <div className="mx-auto flex max-w-shell items-center justify-between px-8 py-2 text-[0.6875rem] uppercase tracking-label" data-id="element-299" data-mp="qznxac2rma0y">
          <p data-id="element-300" data-mp="38qxfxo8v362">{brand.copy.utilityLeft}</p>
          <p className="text-brick" data-id="element-301" data-mp="3ugml8x9buikp">{brand.copy.utilityRight}</p>
        </div>
      </div>

      <div className="mx-auto max-w-shell px-6 md:px-8" data-id="element-302" data-mp="3ues8i687lwrp">
        <div className="flex items-center justify-between py-5" data-id="element-303" data-mp="6uvppki5flyc">
          <Link to="/" className="text-ink" aria-label={`${brand.name} home`} data-id="element-304" data-mp="bu89fwdq4cwp">
            <Logo className="text-base md:text-lg" markClassName="text-brick" data-id="element-305" data-mp="glhxisjmj86h" />
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-6 xl:flex" data-id="element-306" data-mp="lkl44hf95mgk">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `text-sm transition-colors duration-150 ease-brand ${isActive ? 'text-brick' : 'text-ink-soft hover:text-ink'}`} data-id="element-307" data-mp="3k2qhbhxwwi3u">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="hidden items-center gap-6 xl:flex" data-id="element-308" data-mp="19942a44l8iux">
            <Link to="/about" className="text-sm text-ink-soft transition-colors duration-150 ease-brand hover:text-ink" data-id="element-309" data-mp="1dbqwgboqefva">
              Sign in
            </Link>
            <Link to="/start" className="whitespace-nowrap rounded-brand bg-brick px-6 py-3 text-sm font-medium text-cream transition-colors duration-150 ease-brand hover:bg-brick-deep" data-id="element-310" data-mp="35dk6g934fh87">
              Start with one question
            </Link>
          </div>

          <button type="button" onClick={() => setOpen(value => !value)} className="text-ink xl:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-311" data-mp="2qo4h8xj8njum">
            {open ? <XIcon className="h-6 w-6" data-id="element-312" data-mp="30ficgt45pxhy" /> : <MenuIcon className="h-6 w-6" data-id="element-313" data-mp="2vnh3ph676owo" />}
          </button>
        </div>
        <div className="rule" data-id="element-314" data-mp="2vm5xlapa552e" />
      </div>

      <AnimatePresence data-id="element-315" data-mp="27xedl6luft0p">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-b border-ink/10 bg-cream xl:hidden" data-id="element-316" data-mp="27w3c5dfvexcr">
            <nav aria-label="Mobile" className="mx-auto max-w-shell px-6 py-6" data-id="element-317" data-mp="n9lsg00tjgx3">
              <ul className="flex flex-col" data-id="element-318" data-mp="9hnm1wyhrz4m">
                {navItems.map(item => <li key={item.to} className="border-b border-ink/10" data-id="element-319" data-mp="efywa8sp8bnd">
                    <Link to={item.to} className="block py-4 font-serif text-2xl text-ink" data-id="element-320" data-mp="124i64srecwhk">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
              <Link to="/start" className="mt-6 inline-flex rounded-brand bg-brick px-6 py-3 text-sm font-medium text-cream" data-id="element-321" data-mp="s5iy9cegh4vm">
                Start with one question
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}